import React from "react";

const CheckBox = ({ name, label, error, ...rest }) => {
  return (
    <div className="form-group">
      <input type="checkbox" {...rest} name={name} id={name} />
      <label htmlFor={name} className="form-label form-label-sm mx-2"> {label} </label>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default CheckBox;
